import * as fromDatatype from "../../../../models/datatype-library";
import { BaseCriteriaDtoModel } from "./base-dto.model";

export class MembershipCardCriteriaDTO extends BaseCriteriaDtoModel{
    guids?: any[];
    entity_hdr_guids?: any[];
    guid?: string;
    card_no?: string;
    is_card_no_encoded?: string; 
    member_id?: string;
    id_no?: string;
    id_type?: string;
    phone?: string;
    is_phone_encoded?: string; 
    email?: string;
    ref_1?: string;
    ref_2?: string;
    ref_3?: string;
    ref_4?: string;
    ref_5?: string;
    login_subject_guid?: string;
    start_date?: fromDatatype.TimestampTzDatatypeInterface;
    end_date?: fromDatatype.TimestampTzDatatypeInterface;
    entity_hdr_guid?: string;
    company_guid?: string;
    branch_guid?: string;
    created_from?: string;
    created_to?: string;
    contact_key_guid?: string;
    name?: string;
    client_key?: string;
    client_source?: string;
    membership_class_guid?: string;
    membership_class_guids?: any[];
    membership_class_code?: string;
    gender?: string;
    dob?: fromDatatype.TimestampTzDatatypeInterface;
    country_code?: string;
    hdr_created_date_to?: fromDatatype.TimestampTzDatatypeInterface;
    hdr_created_date_on?: fromDatatype.TimestampTzDatatypeInterface;
    hdr_created_date_from?: fromDatatype.TimestampTzDatatypeInterface;
    hdr_updated_date_to?: fromDatatype.TimestampTzDatatypeInterface;
    hdr_updated_date_from?: fromDatatype.TimestampTzDatatypeInterface;
    hdr_updated_date_on?: fromDatatype.TimestampTzDatatypeInterface;
    status_01?: string;
    card_no_like?: string;
    name_like?: string;
    id_no_like?: string;
    id_type_like?: string;
    phone_like?: string;
    email_like?: string;
    member_id_like?: string;
    end_date_from?: fromDatatype.TimestampTzDatatypeInterface;
    end_date_to?: fromDatatype.TimestampTzDatatypeInterface;
    dob_from?: fromDatatype.TimestampTzDatatypeInterface;
    dob_to?: fromDatatype.TimestampTzDatatypeInterface;
    start_date_from?: fromDatatype.TimestampTzDatatypeInterface;
    start_date_to?: fromDatatype.TimestampTzDatatypeInterface;
    card_type?: string;
    card_type_guids?: any[];
    client_customer_code?: string;
    nationality?: string;
    occupation?: string;
    marital_status?: string;
    card_end_date_from?: string;
    card_end_date_to?: string;
    card_start_date_from?: string;
    card_start_date_to?: string;
    xtn_icno?: string;
    xtn_hand_phone?: string;
    xtn_home_phone?: string;
    xtn_office_phone?: string;
    xtn_email?: string;
    param_code?: string;
    param_name?: string;
    value_string?: string;
    value_numeric?: number;
    ext_created_date_to?: fromDatatype.TimestampTzDatatypeInterface;
    ext_created_date_from?: fromDatatype.TimestampTzDatatypeInterface;
    ext_updated_date_to?: fromDatatype.TimestampTzDatatypeInterface;
    ext_updated_date_from?: fromDatatype.TimestampTzDatatypeInterface;
    client_value?: string;
    birthday_months?: any[]; 
    selected_timezone?: string;
    so_delivery_city?: string;
    so_delivery_state?: string;
    so_delivery_postal_code?: string;
}